import axios from 'axios';
import { LuraSignUserData } from 'src/ts/interfaces/user/lura-sign-user-data';

interface LuraSignUserDataParams  {
  userZohoId: string;
  email?: string;
  luraSignUserId?: string;
  phone?: string;
}

export const luraSignUserService = async ({ userZohoId }: LuraSignUserDataParams ) => {
  const url = `/users/lura-sign-user`;
  let response;
  try {
    response = await axios.post(url, { userZohoId });

    const luraSignUserData: LuraSignUserData = response.data.data.user;

    return luraSignUserData;
  } catch (error: any) {
    throw new Error(error);
  }
};